/**
 * @generated SignedSource<<314cb90ae6aa31fd115bf4a379d644ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventStackErrored_event$data = {
  readonly errorDetail?: string | null;
  readonly timestamp: any;
  readonly uuid: string;
  readonly " $fragmentType": "JobEventStackErrored_event";
};
export type JobEventStackErrored_event$key = {
  readonly " $data"?: JobEventStackErrored_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventStackErrored_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventStackErrored_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorDetail",
          "storageKey": null
        }
      ],
      "type": "JobEventStackError",
      "abstractKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "c03c01bdfc1e9e8f6a7cd251e6d15764";

export default node;
